import { c as _c } from "react/compiler-runtime";
import type { StructureArticleDTO } from '@/backend/modules/docs/endpoints/queries/get-collection-structure/output.dto';
import { P3 } from '@/frontend/design-system/typography/Paragraph';
import { cn } from '@/frontend/utils';
type ArticleTitleProps = {
  article: StructureArticleDTO;
  isCurrent: boolean;
};
export function ArticleTitle(t0) {
  const $ = _c(5);
  const {
    article,
    isCurrent
  } = t0;
  const t1 = isCurrent ? "text-contentColorPrimary" : article.hasPublishedVersion ? "text-contentPrimary" : "text-contentSecondary";
  let t2;
  if ($[0] !== t1) {
    t2 = cn(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== article.name || $[3] !== t2) {
    t3 = <P3 className={t2}>{article.name}</P3>;
    $[2] = article.name;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}